<div id="preloader" *ngIf="loadingService.isLoading | async" class="fixed inset-0 z-[99999] flex flex-col items-center justify-center">
    <div class="absolute inset-0 bg-black opacity-80"></div>
    <div class="w-10 h-10 border-4 border-ladder-purpleMedium border-t-ladder-purpleLight rounded-full animate-spin z-10"></div>
  </div>
  